<ion-content>

    <custom-header [showRegistrationLink]="false"
                   [class]="themeConfig.name">
    </custom-header>

    <div class="content-wrapper {{themeConfig.name}}"
         [ngClass]="{'subcommunity': !!themeConfig.name}">
        <div class="background-column-left"></div>

        <div class="content-centered-column">
            <div class="content-centered-row">

                <ion-grid>
                    <ion-row>
                        <ion-col size="12"
                                 size-sm="5"
                                 size-lg="4"
                                 class="main-text">
                            <div *ngIf="!!themeConfig.name">
                                <img *ngIf="!themeConfig.headerLogoLink"
                                     [src]="'/assets/images/theme/' + themeConfig.name + '/logo.png'"
                                     [alt]="community" />
                                <a *ngIf="!!themeConfig.headerLogoLink"
                                   [href]="themeConfig.headerLogoLink"
                                   target="_blank">
                                    <img [src]="'/assets/images/theme/' + themeConfig.name + '/logo.png'"
                                         [alt]="community" />
                                </a>
                            </div>
                            <h1 [innerHtml]="'CUSTOM_MAIN_TITLE' + themeConfig.themeSuffix | translate"></h1>

                            <p [innerHtml]="'CUSTOM_MAIN_TEXT' | translate"></p>
                        </ion-col>
                        <ion-col size="12"
                                 size-sm="7"
                                 size-lg="8"
                                 class="main-form">

                            <form (ngSubmit)="register()"
                                  #f="ngForm"
                                  novalidate>

                                <ion-list class="form">
                                    <ion-item class="ion-no-lines header">
                                        <h1>{{ 'REGISTRATION_TITLE' | translate}}</h1>
                                    </ion-item>

                                    <ion-item class="ion-no-lines">
                                        <p *ngIf="!themeConfig.headerLogoLink"
                                           [innerHtml]="'REGISTRATION_HINT' + source | uppercase | translate : {community: themeConfig.community}"></p>

                                        <p *ngIf="!!themeConfig.headerLogoLink"
                                           [innerHtml]="'REGISTRATION_HINT_WITH_LINK' | translate : {community: themeConfig.community, headerLogoLink:
                                            themeConfig.headerLogoLink}">
                                        </p>
                                    </ion-item>

                                    <ion-row class="ion-no-padding">
                                        <ion-col size="12"
                                                 size-lg="6">

                                            <ion-item class="ion-no-lines">
                                                <!-- <ion-label position="stacked">{{ 'REGISTARTION_LABEL_SALUTATION' | trns }}</ion-label> -->
                                                <ion-select [interface]="selectType"
                                                            [interfaceOptions]="{cssClass: 'not-overflow'}"
                                                            [cancelText]="'BUTTON_CANCEL' |  translate"
                                                            class="ion-padding"
                                                            name="salutation"
                                                            #salutation="ngModel"
                                                            [(ngModel)]="model.salutation">

                                                    <ng-container *ngIf="userLang=='en'">
                                                        <ion-select-option value="">
                                                            {{ 'PLACEHOLDER_PLEASE_NOT_TELL' | translate }}
                                                        </ion-select-option>
                                                        <ion-select-option value="{{ 'LETTER_SALUTATION_VALUE_MRS' | translate }}">
                                                            {{ 'LETTER_SALUTATION_ID_MRS' | translate }}
                                                        </ion-select-option>
                                                        <ion-select-option value="{{ 'LETTER_SALUTATION_VALUE_MS' | translate }}">
                                                            {{ 'LETTER_SALUTATION_ID_MS' | translate }}
                                                        </ion-select-option>
                                                        <ion-select-option value="{{ 'LETTER_SALUTATION_VALUE_MR' | translate }}">
                                                            {{ 'LETTER_SALUTATION_ID_MR' | translate }}
                                                        </ion-select-option>
                                                    </ng-container>
                                                    <ng-container *ngIf="userLang!='en'">
                                                        <ion-select-option value="">
                                                            {{ 'PLACEHOLDER_PLEASE_NOT_TELL' | translate }}
                                                        </ion-select-option>
                                                        <ion-select-option value="{{ 'LETTER_SALUTATION_VALUE_MS' | translate }}">
                                                            {{ 'LETTER_SALUTATION_ID_MS' | translate }}
                                                        </ion-select-option>
                                                        <ion-select-option value="{{ 'LETTER_SALUTATION_VALUE_MR' | translate }}">
                                                            {{ 'LETTER_SALUTATION_ID_MR' | translate }}
                                                        </ion-select-option>
                                                    </ng-container>

                                                </ion-select>
                                            </ion-item>
                                            <span *ngIf="salutation.touched && !salutation.valid"
                                                  class="error-message">
                                                {{ 'VALIDATION_REQUIRED' | trns }}
                                            </span>

                                            <ion-item class="ion-no-lines"
                                                      [ngClass]="{ 'has-error': (firstname.touched || validate) && !firstname.valid }">
                                                <!-- <ion-label position="stacked">{{ 'REGISTRATION_LABEL_FIRSTNAME' | translate }}</ion-label> -->
                                                <ion-input type="text"
                                                           placeholder="{{ 'REGISTRATION_PLACEHOLDER_FIRSTNAME' | translate }}"
                                                           name="firstname"
                                                           [autocomplete]="!!model.firstname ? 'off' : 'on'"
                                                           #firstname="ngModel"
                                                           [(ngModel)]="model.firstname"
                                                           [readonly]="invited"
                                                           required>
                                                </ion-input>
                                            </ion-item>
                                            <span *ngIf="(firstname.touched || validate) && !firstname.valid"
                                                  class="error-message">
                                                {{ 'VALIDATION_REQUIRED' | translate }}
                                            </span>

                                            <ion-item class="ion-no-lines"
                                                      [ngClass]="{ 'has-error': (lastname.touched || validate) && !lastname.valid }">
                                                <!-- <ion-label position="stacked">{{ 'REGISTRATION_LABEL_LASTNAME' | translate }}</ion-label> -->
                                                <ion-input type="text"
                                                           placeholder="{{ 'REGISTRATION_PLACEHOLDER_LASTNAME' | translate }}"
                                                           name="lastname"
                                                           [autocomplete]="!!model.lastname ? 'off' : 'on'"
                                                           #lastname="ngModel"
                                                           [(ngModel)]="model.lastname"
                                                           [readonly]="invited"
                                                           required>
                                                </ion-input>
                                            </ion-item>
                                            <span *ngIf="(lastname.touched || validate) && !lastname.valid"
                                                  class="error-message">
                                                {{ 'VALIDATION_REQUIRED' | translate }}
                                            </span>

                                        </ion-col>

                                        <ion-col size="12"
                                                 size-lg="6">

                                            <ion-item class="ion-no-lines"
                                                      [ngClass]="{ 'has-error': (email.touched || validate) && !email.valid }">
                                                <!-- <ion-label position="stacked">{{ 'REGISTRATION_LABEL_EMAIL' | translate }}</ion-label> -->
                                                <ion-input type="email"
                                                           placeholder="{{ 'REGISTRATION_PLACEHOLDER_EMAIL' | translate }}"
                                                           name="email"
                                                           inputmode="email"
                                                           spellcheck="false"
                                                           autocapitalize="off"
                                                           [autocomplete]="!!model.email ? 'off' : 'on'"
                                                           #email="ngModel"
                                                           [(ngModel)]="model.email"
                                                           [readonly]="invited"
                                                           required
                                                           pattern='^(([^<>\(\)\[\]\\.,;:\s@"]+(\.[^<>\(\)\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'>
                                                </ion-input>
                                            </ion-item>
                                            <span *ngIf="(email.touched || validate) && !email.valid"
                                                  class="error-message">
                                                {{ 'VALIDATION_REQUIRED' | translate }}
                                            </span>

                                            <ion-item class="ion-no-lines"
                                                      [ngClass]="{ 'has-error': (password.touched || validate) && (!password.valid || validationErrors.password)}">
                                                <!-- <ion-label position="stacked">{{ 'REGISTRATION_LABEL_PASSWORD' | translate }}</ion-label> -->
                                                <ion-input type="password"
                                                           placeholder="{{ 'REGISTRATION_PLACEHOLDER_PASSWORD' | translate }}"
                                                           name="password"
                                                           #password="ngModel"
                                                           autocomplete="off"
                                                           [(ngModel)]="model.password"
                                                           required>
                                                </ion-input>
                                            </ion-item>
                                            <span *ngIf="(password.touched || validate) && !password.valid"
                                                  class="error-message">
                                                {{ 'VALIDATION_REQUIRED' | translate }}
                                            </span>
                                            <span *ngIf="validate && validationErrors.password"
                                                  class="error-message">
                                                {{ validationErrors.password }}
                                            </span>

                                            <ion-item class="ion-no-lines"
                                                      [ngClass]="{ 'has-error': (password_confirmation.touched || validate) && (!password_confirmation.valid || validationErrors.password_confirmation)}">
                                                <!-- <ion-label position="stacked">{{ 'REGISTRATION_LABEL_PASSWORD_CONFIRMATION' | translate }}</ion-label> -->
                                                <ion-input type="password"
                                                           placeholder="{{ 'REGISTRATION_PLACEHOLDER_PASSWORD_CONFIRMATION' | translate }}"
                                                           name="password_confirmation"
                                                           #password_confirmation="ngModel"
                                                           autocomplete="off"
                                                           [(ngModel)]="model.password_confirmation"
                                                           required>
                                                </ion-input>
                                            </ion-item>
                                            <span *ngIf="(password_confirmation.touched || validate) && !password_confirmation.valid"
                                                  class="error-message">
                                                {{ 'VALIDATION_REQUIRED' | translate }}
                                            </span>
                                            <span *ngIf="validate && validationErrors.password_confirmation"
                                                  class="error-message">
                                                {{ validationErrors.password_confirmation }}
                                            </span>

                                        </ion-col>
                                    </ion-row>

                                    <ion-row class="ion-no-padding">
                                        <ion-col size="12"
                                                 size-lg="6">
                                            <ion-item class="global checkbox-wrapper ion-no-padding"
                                                      [ngClass]="{ 'has-error': (agb_accepted.touched || validate) && !agb_accepted.valid }">
                                                <ion-checkbox slot="start"
                                                              class="required"
                                                              name="agb_accepted"
                                                              #agb_accepted="ngModel"
                                                              [(ngModel)]="model.agb_accepted"
                                                              required>
                                                </ion-checkbox>
                                                <ion-label *ngIf="!themeConfig.communityToc"
                                                           [innerHtml]="'REGISTRATION_LABEL_AGB' | translate: {community: themeConfig.community, toc: themeConfig.toc[userLang], communityToc: themeConfig.communityToc}">
                                                </ion-label>
                                                <ion-label *ngIf="themeConfig.communityToc"
                                                           [innerHtml]="'REGISTRATION_LABEL_AGB_CUSTOM' | translate: {community: themeConfig.community, toc: themeConfig.toc[userLang], communityToc: themeConfig.communityToc}">
                                                </ion-label>
                                            </ion-item>
                                            <span *ngIf="(agb_accepted.touched || validate) && !agb_accepted.valid"
                                                  class="error-message no-margin-top">
                                                {{ 'VALIDATION_REQUIRED' | translate }}
                                            </span>
                                        </ion-col>

                                        <ion-col size="12"
                                                 size-lg="6">
                                            <ion-item class="global checkbox-wrapper ion-no-padding"
                                                      [ngClass]="{ 'has-error': (data_processing_accepted.touched || validate) && (!data_processing_accepted.valid || validationErrors.agb_accepted) }">
                                                <ion-checkbox slot="start"
                                                              class="required"
                                                              name="data_processing_accepted"
                                                              #data_processing_accepted="ngModel"
                                                              [(ngModel)]="model.data_processing_accepted"
                                                              required>
                                                </ion-checkbox>
                                                <ion-label [innerHtml]="'REGISTRATION_LABEL_DATA_PROCESSING' | translate: {community: themeConfig.community, pp: themeConfig.pp[userLang], communityPp: themeConfig.communityPp}">
                                                </ion-label>
                                            </ion-item>
                                            <span *ngIf="(data_processing_accepted.touched || validate) && !data_processing_accepted.valid"
                                                  class="error-message no-margin-top">
                                                {{ 'VALIDATION_REQUIRED' | translate }}
                                            </span>
                                            <span *ngIf="validate && validationErrors.agb_accepted"
                                                  class="error-message no-margin-top">
                                                {{ validationErrors.agb_accepted }}
                                            </span>
                                        </ion-col>
                                    </ion-row>

                                    <ion-row class="ion-no-padding">
                                        <ion-col size="12"
                                                 size-lg="6">
                                            <ion-item *ngIf="communityTransfer"
                                                      class="global ion-no-padding">
                                                <ion-checkbox slot="start"
                                                              class="required"
                                                              name="transfer_accepted"
                                                              #transfer_accepted="ngModel"
                                                              [(ngModel)]="model.transfer_accepted"></ion-checkbox>
                                                <ion-label [innerHtml]="'REGISTRATION_LABEL_TRANSFER_ACCEPTED' | translate:{'eventName': eventName}"></ion-label>
                                            </ion-item>
                                            <ion-item class="login ion-no-lines ion-no-padding">
                                                <div>
                                                    <a class="link pointer"
                                                       (click)="goToLogin()">
                                                        {{ 'REGISTRATION_LINK_LOGIN' | translate }}
                                                    </a>
                                                </div>
                                            </ion-item>
                                        </ion-col>

                                        <ion-col size="12"
                                                 size-lg="6">
                                            <ion-button expand="block"
                                                        type="submit">
                                                {{ 'REGISTRATION_BUTTON_REGISTER' | translate }}
                                            </ion-button>
                                        </ion-col>
                                    </ion-row>

                                </ion-list>
                            </form>
                            <div *ngIf="!plt.isConnected">
                                <hr class="blue" />
                                {{ 'LOGIN_APP_IS_OFFLINE' | translate }}
                            </div>

                        </ion-col>
                    </ion-row>
                </ion-grid>

            </div>
        </div>

        <div class="background-column-right"></div>

    </div>

    <ng-container *ngIf="!plt.is('cordova')">
        <div class="shape-divider"
             [ngClass]="{'subcommunity': !!themeConfig.name}">
            <svg viewBox="0 0 1000 300"
                 xmlns="http://www.w3.org/2000/svg"
                 preserveAspectRatio="none">
                <path class="ux-shape-fill"
                      opacity="0.15"
                      d="M0 299L-2 19.9998C153 -16.0002 308 155 413 184C515.64 212.35 562 152 645 153C725 154 787 206 874 233C939.54 253.34 975 248 1000 244.61V299H0Z"></path>
                <path class="ux-shape-fill"
                      opacity="0.3"
                      d="M0 300L-2 34C155 -9.00003 300 178 403 212C504.11 245.38 562 165 645 166C725 167 790.09 220.07 874 253C939.21 278.59 978.07 269.72 1000 263.61V300H0Z"></path>
                <path class="ux-shape-fill"
                      d="M0 300L-1 69.7099C216 56.9999 299.47 198.86 403 226C506 253 577 196 660 197C740 198 790.09 234.07 874 267C935.23 291 982 282.61 1000 277.61V300H0Z"></path>
            </svg>
        </div>
        <custom-actors></custom-actors>
        <custom-footer></custom-footer>
    </ng-container>
</ion-content>